import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Figure } from '@studiometa/ui';
import { isDev } from './config.js';
import Stack from './components/Stack.js';
import Mascotte from './components/Mascotte.js';
import SliderHero from './components/SliderHero.js';
import Menu from './components/Menu.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Menu,
      Action,
      Figure,
      Stack,
      Mascotte,
      SliderHero,
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
    },
  };
}

export default createApp(App);
